import { Routes, Route, Navigate } from 'react-router-dom';
import CheckoutPage from './pages/CheckoutPage';

function App() {
    return (
        <Routes>
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="*" element={<Navigate to="/checkout" replace />} />
        </Routes>
    );
}

export default App;
